/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Colors, Typography } from '../../../theme';

type Props = {
  /**
   * The content to render within the component.
   */
  children: React.ReactNode;
};

const Styles = labelStyles('TableHeadHeading', {
  root: css`
    display: flex;
    align-items: center;
    color: ${Colors.gray80};
    ${Typography.smallPrint1Bold};
  `,
});

/**
 * Heading to render within `thead > th`. Use with `TableHeadSortButton`.
 */
export const TableHeadHeading = (props: Props) => {
  return <span css={Styles.root}>{props.children}</span>;
};
